import getLocalValue from '../../../utils/getLocalValue';

// Lets QA force a card holder name field to appear so they can enter a magic value that
// triggers a specific Adyen test error. Hard-blocked in production builds - unlike
// utils/debug.ts's debugEnabled(), the localStorage/window overrides below cannot turn
// this on in a production build, only in development/test builds.
export const paymentErrorTestingEnabled = (): boolean => {
  if (process.env.NODE_ENV === 'production') return false;

  return !!(getLocalValue('TEST_PAYMENT_ERRORS') || window.TEST_PAYMENT_ERRORS);
};
